<template lang="pug">
  b-modal#approveTicket(
    ref="approveTicket"
    :title='$t("ui.combine.approve_ticket")'
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown")
    template(v-if="ticketDetail")
      table.table.mb-3
        thead
          tr
            th(width="35%")
              span  {{ ticketDetail.request_type }}
            th(width="65%")
              span &nbsp;
        tbody
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.member") }}
            td
              span {{ ticketDetail.member_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span {{ $n(ticketDetail.amount, 'currency') }}
              //- span.text-danger(v-if="ticketDetail.exchanged_amount") {{ (ticketDetail.deposit_method.toUpperCase() == 'USDT'? "(" + $n(ticketDetail.exchanged_amount, 'currency') + ")" : "" )}}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.target_bank_id }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.target_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.target_bank_acc_holder }}
          //- tr
          //-   td
          //-     span {{ $t("ui.ref_no") }}
          //-   td
          //-     span {{ ticketDetail.ref_no }}
          tr(v-if="ticketDetail.request_type.toUpperCase() == 'DEPOSIT'")
            td
              span {{ $t("ui.deposit_date") }}
            td
              span(v-if="ticketDetail.deposit_date") {{ $moment(ticketDetail.deposit_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr(v-if="ticketDetail.request_type.toUpperCase() == 'DEPOSIT'")
            td
              span {{ $t("ui.deposit_method") }}
            td
              span {{ ticketDetail.deposit_method }}
          tr(v-if="ticketDetail.request_type.toUpperCase() == 'DEPOSIT'")
            td
              span {{ $t("ui.promo") }}
            td
              span {{ ticketDetail.promotion_id }}
          //- tr(v-if="ticketDetail.deposit_method == 'USDT'")
          //-   td
          //-     span {{ $t("ui.rate") }}
          //-   td
          //-     span {{ ticketDetail.rate }}
          //- tr(v-if="ticketDetail.deposit_method == 'USDT'")
          //-   td
          //-     span {{ $t("ui.rate_php") }}
          //-   td
          //-     span {{ ticketDetail.rate_php }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span.font-weight-bold.text-info {{ ticketDetail.status.trim().toUpperCase() }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_date") }}
            td
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
      b-form-group(:label="$t('ui.sender_bank')" v-if="ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL'").mb-0
        BankListAutoWithdrawal(
          ref="senderBank"
          size="sm"
          type="array"
          :dirty="$v.sender_bank.$dirty"
          :error="$v.sender_bank.$error"
          v-model.trim.lazy="$v.sender_bank.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.sender_bank" :name="$t('ui.sender_bank')")
      b-form-group(:label="$t('ui.remark')" v-if="ticketDetail.status.trim().toUpperCase() != 'REJECTED'").mb-0
        DebounceInput(
          size="sm"
          type="text"
          v-model="remark"
          :disabled="loading"
        )
      div(slot="modal-footer")
        SubmitButton.float-right(icon="fa fa-check" :text="$t('ui.approve')" @click="approveTicket()" size="sm" variant="secondary" v-if="showApproveBtn()" :loading="loading")
        //- SubmitButton.float-right(icon="fa fa-ban" :text="$t('ui.reject')" @click="rejectTicket()" size="sm" variant="danger" v-if="ticketDetail.status == 1").mr-1
        SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary" :loading="loading").mr-1
</template>

<script>
import { required, minLength, maxLength, url, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import BankAccountList from "@/library/BankAccountList";
import BankListAutoWithdrawal from "@/library/BankListAutoWithdrawal";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BankAccountList,
    BankListAutoWithdrawal,
    ValidateResult
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    },
    parentId:{
      type: String,
      default: ""
    },
    memberId:{
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      memberDetail: null,
      sender_bank: '',
      remark: '',
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {

  },
  mounted: function() {
  },
  validations: {
    sender_bank: {
      required : requiredIf(function () {
        return this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL';
      }),
    },
  },
  methods: {
    showApproveBtn() {
      if (this.ticketDetail.request_type.toUpperCase() == 'DEPOSIT' && this.ticketDetail.status.trim().toUpperCase() == 'PENDING')
        return true;
      // else if (this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL' && this.ticketDetail.status.trim().toUpperCase() == 'REVIEW')
      //   return true;
      else if (this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL' && this.ticketDetail.status.trim().toUpperCase() == 'AUDIT')
        return true;
      else
        return false;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.sender_bank = '';
      this.remark = '';
      this.getTicketDetail();
    },
    getTicketDetail: function() {
      let url = config.ticketDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    approveTicket: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmApproveTicket();
      }
    },
    confirmApproveTicket: function() {
      let url = '';
      if (this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL') {
        var bank_acc_no = this.sender_bank.split(' - ')[1].trim();

        if (bank_acc_no == "RMPAY")
          url = config.withdrawalRMPayUrl();
        else if (bank_acc_no == "AIPAY")
          url = config.withdrawalAIPayUrl();
        else if (bank_acc_no == "HTPAY")
          url = config.withdrawalHTPayUrl();
        else if (bank_acc_no == "MAYAPAY")
          url = config.withdrawalMAYAPayUrl();
        else if (bank_acc_no == "GOPAYGCASH")
          url = config.withdrawalGOPayGcashUrl();
        else if (bank_acc_no == "GOPAYMAYA")
          url = config.withdrawalGOPayMayaUrl();
        else if (bank_acc_no == "DGPAYGCASH")
          url = config.withdrawalDGPayGcashUrl();
        else if (bank_acc_no == "DGPAYMAYA")
          url = config.withdrawalDGPayMayaUrl();
        else if (bank_acc_no == "CLOUDPAY")
          url = config.withdrawalCloudPayUrl();
        else if (bank_acc_no == "TOPPAY")
          url = config.withdrawalTopPayUrl();
        else if (bank_acc_no == "ANFU")
          url = config.withdrawalANFUUrl();
        else if (bank_acc_no == "SHUNFAPAYGCASH")
          url = config.withdrawalShunfaPayGcashUrl();
        else if (bank_acc_no == "SHUNFAPAYMAYA")
          url = config.withdrawalShunfaPayMayaUrl();
        else if (bank_acc_no == "WORLDPAY")
          url = config.withdrawalWorldPayUrl();
        else if (bank_acc_no == "RGPAY")
          url = config.withdrawalRGPayUrl();
        else if (bank_acc_no == "WCPAY")
          url = config.withdrawalWCPayUrl();
        else if (bank_acc_no == "GOLDPAY")
          url = config.withdrawalGOLDPayUrl();
        else if (bank_acc_no == "XFTGCASH")
          url = config.withdrawalXFTGcashUrl();
        else if (bank_acc_no == "MASAYAPAY")
          url = config.withdrawalMasayaPayUrl();
        else if (bank_acc_no.startsWith('TYGPAY'))
          url = config.withdrawalTYGPayUrl();
        else if (bank_acc_no == "XYPAY")
          url = config.withdrawalXYPayUrl();
        else if (bank_acc_no == "XFTUSDT")
          url = config.withdrawalXFTUsdtUrl();
        else if (bank_acc_no == "CTPAY")
          url = config.withdrawalCTPayUrl();
      }
      else if (this.ticketDetail.request_type.toUpperCase() == 'DEPOSIT')
        url = config.ticketApproveDepositUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_id: this.ticketDetail.id,
        remark: this.remark,
        audit_by: this.$store.getters.loginId,
      };

      if(this.ticketDetail.request_type.toUpperCase() == 'WITHDRAWAL') {
        json.target_bank_id = this.ticketDetail.target_bank_id; //GP / PMP / GCASH / UNIBANK
        json.ref_no = this.ticketDetail.ref_no;
        json.sender_bank_id = this.sender_bank.split(' - ')[0].trim(); //gateway
        json.sender_bank_acc_no = this.sender_bank.split(' - ')[1].trim(); //dgpaymaya
        json.amount = this.ticketDetail.amount;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.approveTicket.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$v.$reset();
      this.$refs.approveTicket.hide();
    },
  }
};
</script>
